import driverService, { DRIVER_URIS } from "./driver-service";
import siteService, { SITE_URIS } from "./site-service";
import subContractService, { SUBCONTRACT_URIS } from "./subcontract-service";
import vehicleService, { VEHICLE_URIS, TRAILER_URIS} from "./vehicle-service";
import customerService from "./customer-service";
import trackingActivityService from "./tracking-activity-service";
import routecodeService from "./routecode-service";
import temperatureService,{ TEMPERATURE_URIS } from "./temperature-service";
import resetStopService, { REST_STOP_URIS } from "./rest-stop-service";
import transportFeeService, { TRANSPORT_FEE_URI_PREFIX } from "./transport-fee-service"
import settingsService from './settings'

export { SUBCONTRACT_URIS, DRIVER_URIS, VEHICLE_URIS, SITE_URIS, TEMPERATURE_URIS, REST_STOP_URIS, TRAILER_URIS, TRANSPORT_FEE_URI_PREFIX};

const services = {
  ...driverService,
  ...subContractService,
  ...vehicleService,
  ...siteService,
  ...customerService,
  ...trackingActivityService,
  ...routecodeService,
  ...temperatureService,
  ...resetStopService,
  ...transportFeeService,
  ...settingsService
};
let abortControllers = {};

export function doApi(service, params, config) {
  const controller = exportService.cancelRequest(service.name);
  const signal = controller.signal;
  return service(params, signal, config);
}
const exportService = { ...services };
Object.keys(exportService).forEach((key) => {
  exportService[key] = (params, config) => doApi(services[key], params, config);
  abortControllers[key] = new AbortController();
});
exportService.cancelRequest = (service) => {
  const key = typeof service === "string" ? service : service.name;
  if (abortControllers[key]) {
    abortControllers[key].abort();
    abortControllers[key] = new AbortController();
  }
  return abortControllers[key];
};
export default {
  ...exportService,
};



// WEBPACK FOOTER //
// ./src/services/index.js